import { createFileRoute } from "@tanstack/react-router";
import { RunsScreen } from "../screens/staff/RunsScreen.tsx";

/**
 * `/sysadmin/runs/:accessId`: the runs of the company that said yes. The first read is written to the company's security
 * log, so the page doesn't refetch on its own (every refetch would be another line there). When the access has ended
 * the answer is "no access" and the page says so.
 */
export const Route = createFileRoute("/_staff/sysadmin/runs/$accessId/")({
  component: RunsScreen,
});
